import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

const Item = styled.tr`
  padding-left: 12px;
  height: 30px;
  color: ${props =>
    props.active ? props.theme.colors.brand : props.theme.colors.black};
  transition: background-color 200ms ease-in;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 120, 84, .5);
    transition: background-color 0ms ease-in;
  }
`;

const baseCellStyles = css`
  font-size: 15px;
  padding: 7px 9px 10px;
  vertical-align: top;
`;

const LabelCell = styled.td`
  ${baseCellStyles} white-space: ${props =>
      props.hasDescription ? 'nowrap' : 'pre-wrap'};
`;

const DescriptionCell = styled.td`
  ${baseCellStyles} width: 100%;
  white-space: pre-wrap;
`;

class DefaultDropdownItem extends Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    item: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string
    }).isRequired,
    onChange: PropTypes.func
  };

  static defaultProps = {
    value: null,
    onChange: null
  };

  onChange = () => {
    if (!this.props.onChange) return;
    this.props.onChange(this.props.item.value);
  };

  render() {
    return (
      <Item
        active={this.props.item.value === this.props.value}
        onClick={this.onChange}
        className="dropdown-item"
      >
        <LabelCell hasDescription={Boolean(this.props.item.description)}>
          {this.props.item.label}
        </LabelCell>
        {this.props.item.description && (
          <DescriptionCell>{this.props.item.description}</DescriptionCell>
        )}
      </Item>
    );
  }
}

export default DefaultDropdownItem;



// WEBPACK FOOTER //
// ./src/components/units/Dropdown/DefaultDropdownItems/DefaultDropdownItem.js